import { render, staticRenderFns } from "./RegistrationStep2.vue?vue&type=template&id=6664987a&scoped=true"
import script from "./RegistrationStep2.vue?vue&type=script&lang=js"
export * from "./RegistrationStep2.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep2.vue?vue&type=style&index=0&id=6664987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664987a",
  null
  
)

export default component.exports